module.exports = __webpack_public_path__ + "img/team2_2.0a6677e3.jpg";